export const SOURCE_TYPE_LABELS = {
  original_request: "Original request",
  conversation_decision: "Conversation decision",
  screenshot: "Screenshot",
  prd: "PRD",
  document: "Document",
  repository: "Repository evidence",
  linked_issue: "Linked issue",
  note: "Note",
  ai_accepted: "Accepted suggestion",
};

export const SOURCE_USAGE_LABELS = {
  requirement: "Requirement",
  context: "Context",
  example: "Example",
};

export function sourceDisplayName(item = {}) {
  const name = item?.name;
  if (typeof name === "string" && name.trim() && name !== "[object Object]") return name.trim();
  return SOURCE_TYPE_LABELS[item?.type] || "Source";
}

export function sourceTypeLabel(type) {
  return SOURCE_TYPE_LABELS[type] || "Source";
}

export function sourceUsageLabel(usage) {
  return SOURCE_USAGE_LABELS[usage] || "Context";
}

export function isRiskItem(item) {
  return item?.kind !== "deferral";
}

export function isActiveDeferral(item) {
  return item?.kind === "deferral" && !item?.resolved;
}

export function partitionRisks(items = []) {
  return {
    risks: items.filter((item) => isRiskItem(item) && !item?.resolved),
    deferrals: items.filter((item) => isActiveDeferral(item)),
  };
}

export function focusTaskSectionId(section) {
  return section ? `full-task-${section}` : "full-task-outcome";
}
